import React, { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  useLocation,
} from "react-router-dom";
import "./App.css";

// Components
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Institution from "./Components/Institution/Institution";
import Service from "./Components/Service/Service";
import Contact from "./Components/Contact/Contact";
import ForMedicalFaculty from "./Components/ForMedicalFaculty/ForMedicalFaculty";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import Disclaimer from "./Components/Disclaimer/Disclaimer";
import CookiePolicy from "./Components/CookiesPolicy/CookiePolicy";

// Standard Service Pages
import StandardServicePage from "./Components/Service/Services-Page/StandardServicePage/StandardServicePage";
import {
  mbbsExpansionData,
  pgExpansionData,
  complianceData,
  documentationData,
  newMedicalCollegeData,
  facultyRecruitmentData,
} from "./Components/Service/Services-Page/StandardServicePage/ServicesData";

// Admin Pages
import AdminSignIn from "./AdminPages/AdminSignIn/AdminSignIn";
import AdminProtectedRoute from "./AdminPages/AdminProtectedRoute";
import AdminLayout from "./AdminPages/AdminLayout";
import ViewContact from "./AdminPages/Contact/ViewContact";
import FacultyRegistrationForm from "./AdminPages/FacultyRegistrationForm/FacultyRegistrationForm";
import InstitutionalEnquries from "./AdminPages/InstitutionalEnquries/InstitutionalEnquries";
import Gallery from "./Components/Gallery/Gallery";
import AddGallery from "./AdminPages/AddGallery/AddGallery";
import PageNotFound from "./Components/PageNotFound/PageNotFound";
import AdminDashboard from "./AdminPages/AdminDashboard/AdminDashboard";
import ChangePassword from "./AdminPages/ChangePassword/ChangePassword";

// ── पेज बदलने पर ऊपर स्क्रॉल करने के लिए ──
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// ── Public Layout (सिर्फ यहीं Navbar और Footer रहेगा) ──
const PublicLayout = () => {
  return (
    <>
      <Navbar />
      <main className="main-content-wrapper">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Nutrivio Medical Services Private Limited</title>
        <meta
          name="description"
          content="Specialised Medical Education Institutional Advisory & Professional Services Company."
        />
      </Helmet>

      <Router>
        <ScrollToTop />
        <Routes>
          {/* ═══════════ PUBLIC ROUTES (With Navbar & Footer) ═══════════ */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Service />} />
            <Route path="/for-institutions" element={<Institution />} />
            <Route path="/for-medical-faculty" element={<ForMedicalFaculty />} />
            <Route path="/contact" element={<Contact />} />

            {/* 6 Standard Service Pages */}
            <Route
              path="/services/new-medical-college-establishment"
              element={<StandardServicePage {...newMedicalCollegeData} />}
            />
            <Route
              path="/services/mbbs-seat-expansion"
              element={<StandardServicePage {...mbbsExpansionData} />}
            />
            <Route
              path="/services/pg-course-seat-expansion"
              element={<StandardServicePage {...pgExpansionData} />}
            />
            <Route
              path="/services/institutional-compliance"
              element={<StandardServicePage {...complianceData} />}
            />
            <Route
              path="/services/documentation-readiness"
              element={<StandardServicePage {...documentationData} />}
            />
            <Route
              path="/services/medical-faculty-recruitment"
              element={<StandardServicePage {...facultyRecruitmentData} />}
            />

            <Route path="/gallery" element={<Gallery />} />
            <Route path="/*" element={<PageNotFound />} />

            {/* Legal Pages */}
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Route>

          {/* ═══════════ ADMIN LOGIN (No Navbar/Footer) ═══════════ */}
          <Route path="/admin" element={<AdminSignIn />} />

          {/* ═══════════ PROTECTED ADMIN ROUTES ═══════════ */}
          <Route
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route path="/admin/dashboard" element={<AdminDashboard/>} />
            <Route path="/admin/view-contact" element={<ViewContact />} />
            <Route path="/admin/faculty-registrations" element={<FacultyRegistrationForm />} />
            <Route path="/admin/institutional-enquiries" element={<InstitutionalEnquries />} />
            <Route path="/admin/add-gallery" element={<AddGallery />} />
            <Route path="/admin/change-password" element={<ChangePassword />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}